module.exports = __webpack_public_path__ + "img/success-circle.c8048773.svg";